import React from 'react';

const TileGroup = ({groupBy, elements, hideLabel, labelStyles = defaultLabelStyles, itemStyles = defaultItemStyles}) => {

    return(
        elements.length > 0 &&
        <div>
            {!hideLabel && <p style={labelStyles}>{groupBy}</p>}
            <div style={itemStyles}>{elements}</div>
        </div>
    )
}

const defaultItemStyles = {
    display: 'flex',
    flexWrap: 'wrap'
}

const defaultLabelStyles = {
    fontSize: '18px',
    fontWeight: 'bold'
}


export default TileGroup


// WEBPACK FOOTER //
// ./src/components/ManageCenter/TileGroup.js